export const HOME_CONTENT_PRODUCT_ID = 4;
export const BUILDING_PRODUCT_ID = 3;
export const PERSONAL_SAFETY_PRODUCT_ID = 12;
export const BLING_BRAND_NEW_PRODUCT_ID = 21;
export const BLING_LIKE_NEW_PRODUCT_ID = 22;
export const BLING_SCREEN_FIX_PRODUCT_ID = 23;
export const MOTOR_COMPREHENSIVE_PRODUCT_ID = 1;
export const MOTORBIKE_COMPREHENSIVE_PRODUCT_ID = 7;
export const CHILLI_COMPREHENSIVE_PRODUCT_ID = 2;
export const PORTABLE_POSSESSION_PRODUCT_ID = 6;

export const AMEND_POLICY_BLING = "AMEND_POLICY_BLING";
export const AMEND_POLICY_CAR = "AMEND_POLICY_CAR";
export const AMEND_POLICY_PORTABLE = "AMEND_POLICY_PORTABLE";

export const CELLPHONE_CLAIM_ACCIDENTAL_ID = 2;
export const CELLPHONE_CLAIM_INTENTIONAL_ID = 7;
export const CELLPHONE_CLAIM_LOSS_ID = 8;
export const CELLPHONE_CLAIM_THEFT_ID = 11;
export const CELLPHONE_CLAIM_OTHER_ID = 999;

export const CAR_PRODUCT_VAPS_SCRATCH_AND_DENT_GUID = "0EC1DCAA-A6F7-4C86-905A-00FD55022569";
export const CAR_PRODUCT_VAPS_TYRE_AND_RIM_GUID = "916E328E-AD96-4D6C-A3E8-42B095BCB805";
export const CAR_PRODUCT_VAPS_DINGS_AND_THINGS_GUID = "5EEDC56C-F17A-4AB8-97CC-58E02D612865";

export const CAR_CLAIM_VAPS_SCRATCH_AND_DENT_ID = 90001;
export const CAR_CLAIM_VAPS_TYRE_AND_RIM_ID = 90002;
export const CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID = 90003;

export const CODE_RED_PRODUCT_GUID = "E4DE81F3-E984-4BF1-8673-519BC1A2566A"

export const BUILDING_COMPREHENSIVE_PRODUCT_GUID = "4C0CB071-42DD-4060-99FF-9F0214113457";
export const HOME_CONTENT_COMPREHENSIVE_PRODUCT_GUID = "4C0CB071-42DD-4060-99FF-9F0214113456";
export const HOME_CONTENT_FIREFURY_PRODUCT_GUID = "527C8565-73A1-4F04-8B8E-2ACBC4E0D0C3";

export const PRODUCT_TYPES = {
    PersonalLines: 1,
    ValueAddedProduct: 2,
    PolicyBenefit: 3,
    CoverBenefit: 4,
};

export const POLICY_COVER_PRODUCTS = {
    Car: 1,
    Chilli: 2,
    Building: 3,
    Content: 4,
    Trailer: 5,
    Caravan: 13,
    PortablePossessions: 6,
    Motorbike: 7,
    Warranty: 8,
    Watercraft: 9,
    PersonalAccident: 10,
    Other: 12,
    BlingBrandNew: 21,
    BlingLikeNew: 22,
    BlingScreenFix: 23,
    LifeInsurance: 201,
};